import { render } from "./LocationsByBrowserLocation.vue?vue&type=template&id=88612d04&ts=true"
import script from "./LocationsByBrowserLocation.vue?vue&type=script&lang=ts"
export * from "./LocationsByBrowserLocation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__